import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import PluginEntry from '../../components/PluginEntry';
import isMobile from '../../utils/isMobile';
import { useDebounceFn } from 'ahooks';
import { openPortkeyPluginPage } from '../../utils/pluginPages';
import isPortkeyApp from '../../utils/isPortkeyApp';
import openPageInDiscover from './openDiscoverPage';
import { ExtraWalletContext } from '../../context';
export default function DiscoverPlugin({ detectState, version, onClick, }) {
    const { discover: discoverOpts } = useContext(ExtraWalletContext);
    const _version = useMemo(() => (version === 'v1' ? 'v1' : undefined), [version]);
    const { run: onClickInternal } = useDebounceFn(async () => {
        if (isMobile() && !isPortkeyApp()) {
            openPageInDiscover(undefined, _version);
            return;
        }
        if (detectState === 'not-detected' && !isMobile()) {
            if (discoverOpts?.onPluginNotFound) {
                discoverOpts?.onPluginNotFound(openPortkeyPluginPage);
            }
            else {
                openPortkeyPluginPage(_version);
            }
            return;
        }
        if (detectState === 'unknown')
            return;
        onClick();
    }, {
        wait: 500,
        maxWait: 500,
        leading: true,
        trailing: false,
    });
    const onClickButton = () => {
        if (discoverOpts.onClick) {
            discoverOpts.onClick(onClickInternal);
        }
        else {
            onClickInternal();
        }
    };
    return version === 'v1' ? (_jsx(PluginEntry, { name: _jsxs(_Fragment, { children: ["Portkey", _jsx("br", {}), _jsx("span", { className: "nowrap early-access", children: "(Deprecated)" })] }), icon: 'discover', onClick: onClickButton })) : (_jsx(PluginEntry, { name: 'Portkey Wallet', icon: 'discoverV2', onClick: onClickButton }));
}
